module.exports = __webpack_public_path__ + "static/media/cross.6be5400c.svg";